<h1 matDialogTitle>Deconnexion</h1>

@if(load){
  <mat-dialog-content>
    <mat-spinner></mat-spinner>
  </mat-dialog-content>
}@else {
  <mat-dialog-content>
    Etez-vous sur de vouloir vous deconnecter
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-raised-button color="accent" (click)="logout()">Oui</button>
    <button mat-flat-button matDialogClose>Non</button>
</mat-dialog-actions>
}
